import "./polyfills"; // For IE 11 support
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { AuthProvider } from "./lib/auth";
import apolloClient from "./ApolloClient";
import "bootstrap/dist/css/bootstrap.css";
import "react-instantsearch-theme-algolia/style.css";
import "./index.css";
import App from "./components/App";
import RaygunUser from "./Raygun";
import { unregister } from "./registerServiceWorker";
import RouteChangeHandler from "./lib/Segment/RouteChangeHandler";

if (typeof IntersectionObserver !== "undefined") {
  const originalObserve = IntersectionObserver.prototype.observe;
  IntersectionObserver.prototype.observe = function (target) {
    const isSafeTarget =
      target &&
      target.nodeType === 1 &&
      target.ownerDocument &&
      typeof target.ownerDocument.contains === "function" &&
      target.ownerDocument.contains(target);

    if (!isSafeTarget) {
      return;
    }

    try {
      return originalObserve.call(this, target);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(
        "IntersectionObserver.observe blocked due to invalid target:",
        error
      );
    }
  };
}

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <App />
        <RouteChangeHandler />
        <RaygunUser />
      </AuthProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
unregister();
